import confetti from "canvas-confetti";
import { PropsWithChildren, useEffect, useRef } from "react";

interface Props extends PropsWithChildren {
  sprayWhen?: boolean;
}

export function ConfettiSideCannons({ children, sprayWhen }: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !sprayWhen) return;

    const confettiInstance = confetti.create(canvas, { resize: true });
    const end = Date.now() + 3 * 1000; // 3 seconds
    const colors = ["#a786ff", "#fd8bbc", "#eca184", "#f8deb1"];

    const frame = () => {
      if (Date.now() > end) return;

      confettiInstance({
        particleCount: 2,
        angle: 60,
        spread: 55,
        startVelocity: 60,
        origin: { x: 0, y: 0.5 },
        colors: colors,
      });

      confettiInstance({
        particleCount: 2,
        angle: 120,
        spread: 55,
        startVelocity: 60,
        origin: { x: 1, y: 0.5 },
        colors: colors,
      });

      requestAnimationFrame(frame);
    };

    frame();
  }, [sprayWhen]);

  return (
    <div className="testify-relative testify-inline-block testify-w-full testify-h-full">
      <canvas
        ref={canvasRef}
        className="testify-absolute testify-top-0 testify-left-0 testify-pointer-events-none testify-w-full testify-h-full"
      />
      {children}
    </div>
  );
}
